export function SET_ERROR(state, balanceError) {
    state.balanceError = balanceError;
}
export function SET_BALANCE_SUCCESS(state, balanceSuccess) {
    state.balanceSuccess = balanceSuccess;
}
export function SET_BALANCE_LOADING(state, isBalanceLoading) {
    state.isBalanceLoading = isBalanceLoading;
}
export function SET_BALANCE_ITEM(state, balanceItem) {
    state.balanceItem = balanceItem;
}
export function SET_SELECTED_EDUCATION(state, selectedEducation) {
    state.selectedEducation = selectedEducation;
}
export default {
    SET_ERROR,
    SET_BALANCE_SUCCESS,
    SET_BALANCE_LOADING,
    SET_BALANCE_ITEM,
    SET_SELECTED_EDUCATION,
};
